/* Final 100 — countdown + live cart ladder */
(function () {
  if (window.F100Loaded) return;
  window.F100Loaded = true;

  /* ---------- Countdown ---------- */
  class F100Countdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.getAttribute('data-end')).getTime();
      this.els = {
        d: this.querySelector('[data-d]'),
        h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'),
        s: this.querySelector('[data-s]')
      };
      if (isNaN(this.end)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      let diff = Math.max(0, this.end - Date.now());
      if (diff === 0) { this.classList.add('is-done'); clearInterval(this.timer); }
      this.classList.toggle('is-urgent', diff > 0 && diff < 48 * 36e5);
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      const pad = (n) => String(n).padStart(2, '0');
      if (this.els.d) this.els.d.textContent = pad(d);
      if (this.els.h) this.els.h.textContent = pad(h);
      if (this.els.m) this.els.m.textContent = pad(m);
      if (this.els.s) this.els.s.textContent = pad(s);
    }
  }
  if (!customElements.get('f100-countdown')) customElements.define('f100-countdown', F100Countdown);

  /* ---------- Cart ladder ----------
     Counts items in the cart (sum of quantities, so a pair or a set = 1 item),
     highlights unlocked tiers, shows "add N more", and writes the unlocked
     tier into a cart attribute so it shows on the order for fulfillment. */
  let cartCache = null;
  let fetching = null;
  function fetchCart() {
    if (fetching) return fetching;
    fetching = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => { cartCache = c; fetching = null; return c; })
      .catch(() => { fetching = null; return cartCache; });
    return fetching;
  }

  const ladders = new Set();
  let lastAttr = null;
  let lastProps = null;
  const PROP = 'Free gifts included';

  function isSetItem(i) {
    const t = (i.product_type || '').toLowerCase();
    return t === 'full set' || t === 'fine art print set' || /complete-collection|full-set|complete-set/.test(i.handle || '');
  }
  function isExtraItem(i) {
    const t = (i.product_type || '').toLowerCase();
    return /^mystery-(art-card|sticker)/.test(i.handle || '') || t === 'art cards' || t === 'sticker pack' || t === 'art card' || t === 'sticker';
  }
  /* Prints that count toward the tiers: everything except the Complete Set and the art card / sticker add-ons
     (the Mystery Print counts like any other print) */
  function printCount(cart) {
    const items = cart.items || [];
    if (!items.length) return cart.item_count || 0;
    return items.reduce((n, i) => n + (isSetItem(i) || isExtraItem(i) ? 0 : (i.quantity || 0)), 0);
  }
  function hasSetItem(cart) { return (cart.items || []).some(isSetItem); }

  function refreshAll() {
    fetchCart().then((cart) => {
      if (!cart) return;
      ladders.forEach((l) => l.render(cart));
      applyCardDiscounts(cart);
      tidyVariantLabels();
      syncFooter(cart);
      syncAttribute(cart);
      syncLineProps(cart);
    });
  }

  /* The product option is named "Size:" so the theme prints "Size:: 16 x 20 inches"; collapse the double colon */
  function tidyVariantLabels() {
    document.querySelectorAll('.cart__item__variant, .cart__item__property, .cart__item__selected-options span, .cart__item__selected-options, .cart-bar__product__variant').forEach((el) => {
      if (el.children.length === 0 && el.textContent.indexOf('::') > -1) el.textContent = el.textContent.replace(/::/g, ':');
    });
  }

  /* Cart drawer footer: "Subtotal" (struck through) / discount line / "Total" after discounts */
  function syncFooter(cart) {
    document.querySelectorAll('[data-cart-price-holder]').forEach((holder) => {
      const sub = holder.querySelector('.cart__total:not(.f100-total)');
      let total = holder.querySelector('.f100-total');
      const discounted = (cart.total_discount || 0) > 0 && sub && !sub.classList.contains('hidden');
      if (!discounted) { if (total) total.remove(); if (sub) sub.classList.remove('f100-sub'); return; }
      sub.classList.add('f100-sub');
      const label = sub.querySelector('span:first-child');
      if (label && label.textContent.trim().toLowerCase() !== 'subtotal') label.textContent = 'Subtotal';
      const sample = (sub.querySelector('[data-cart-total]') || sub.querySelector('span:last-child') || {}).textContent || '';
      if (!total) {
        total = document.createElement('div');
        total.className = 'cart__total f100-total';
        total.innerHTML = '<span>Total</span><span data-f100-total></span>';
        const disc = holder.querySelector('.cart__discounts');
        if (disc) disc.insertAdjacentElement('afterend', total); else sub.insertAdjacentElement('afterend', total);
      }
      const out = total.querySelector('[data-f100-total]');
      const val = fmtLike(sample.trim(), cart.total_price || 0);
      if (out && out.textContent !== val) out.textContent = val; /* only touch the DOM when it changes (the drawer observer watches this area) */
    });
  }

  /* ---------- Live discounted prices on the product cards ---------- */
  const TIERS_FALLBACK = [
    { min: 2, discount: '5% off' }, { min: 3, discount: '10% off' }, { min: 5, discount: '15% off' }, { min: 10, discount: '20% off' }
  ];
  const ELIGIBLE = 'final-100-prints-eligible';
  function tierPct(count) {
    const first = ladders.values().next().value;
    const tiers = (first && first.tiers && first.tiers.length) ? first.tiers : TIERS_FALLBACK;
    let pct = 0;
    tiers.forEach((t) => { if (count >= t.min) { const m = /(\d+)\s*%/.exec(t.discount || ''); if (m) pct = parseInt(m[1], 10); } });
    return pct;
  }
  /* Format a cents amount the same way the sample price string is formatted ("$60", "€55,95", "US$1,234.00") */
  function fmtLike(sample, cents) {
    const m = /^(\D*)([\d.,\s]+)(\D*)$/.exec(sample || '');
    if (!m) return sample;
    const num = m[2].trim();
    let dec = '.';
    const dm = /([.,])(\d{2})$/.exec(num);
    if (dm) dec = dm[1];
    else if (num.indexOf(',') > -1 && num.indexOf('.') === -1 && !/,\d{3}$/.test(num)) dec = ',';
    const thou = dec === '.' ? ',' : '.';
    const total = Math.round(cents);
    const hasFrac = total % 100 !== 0 || !!dm;
    const whole = Math.floor(total / 100);
    const frac = String(total % 100).padStart(2, '0');
    const wholeStr = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return m[1] + (hasFrac ? wholeStr + dec + frac : wholeStr) + m[3];
  }
  /* The next tier up from a print count: { min, pct } or null at the top */
  function nextTierInfo(count) {
    const first = ladders.values().next().value;
    const tiers = (first && first.tiers && first.tiers.length) ? first.tiers : TIERS_FALLBACK;
    for (let i = 0; i < tiers.length; i++) {
      if (count < tiers[i].min) {
        const m = /(\d+)\s*%/.exec(tiers[i].discount || '');
        return { min: tiers[i].min, pct: m ? parseInt(m[1], 10) : 0 };
      }
    }
    return null;
  }
  let currentPct = 0;
  let currentCount = 0;
  function applyCardDiscounts(cart) {
    currentCount = printCount(cart);
    currentPct = tierPct(currentCount);
    document.querySelectorAll('f100-card, f100-product').forEach((card) => { if (typeof card.renderPrice === 'function') card.renderPrice(); });
  }

  function tierLabel(tiers, count) {
    let label = 'None';
    tiers.forEach((t) => { if (count >= t.min) label = t.min + '+ prints: ' + t.discount + ' + ' + t.gift; });
    return label;
  }

  /* Names of the free gifts unlocked right now (used in the drawer summary and at checkout) */
  function giftNames(cart) {
    const first = ladders.values().next().value;
    if (!first) return '';
    const count = printCount(cart);
    const set = hasSetItem(cart);
    const names = [];
    first.rows.forEach((row) => {
      const min = parseInt(row.getAttribute('data-tier'), 10);
      const name = row.getAttribute('data-gift-name');
      if (!name) return;
      if (row.hasAttribute('data-sets')) { if (set) names.push(name); return; }
      if (set || count >= min) names.push(name);
    });
    return names.join(', ');
  }

  function syncAttribute(cart) {
    const first = ladders.values().next().value;
    if (!first || !first.tiers.length) return;
    const count = printCount(cart);
    const set = hasSetItem(cart);
    let label = count > 0 ? tierLabel(first.tiers, count) : '';
    if (set) label = 'Complete Set: 25% off + all gifts + special extras';
    const current = (cart.attributes && cart.attributes['Final 100 Gifts']) || '';
    if (label === current || label === lastAttr) return;
    lastAttr = label;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Final 100 Gifts': label } })
    }).catch(() => {});
  }

  /* Write "Free gifts included: ..." onto the first line item so it shows at checkout and on the order */
  let propsBusy = false;
  function syncLineProps(cart) {
    const items = cart.items || [];
    if (!items.length || propsBusy) return;
    const want = giftNames(cart);
    const key = want + '|' + items.map((i) => i.key).join(',');
    if (key === lastProps) return;
    const changes = [];
    items.forEach((i, idx) => {
      const have = (i.properties && i.properties[PROP]) || '';
      const target = idx === 0 ? want : '';
      if (have !== target) {
        const props = Object.assign({}, i.properties || {});
        props[PROP] = target;
        changes.push({ line: idx + 1, quantity: i.quantity, properties: props });
      }
    });
    lastProps = key;
    if (!changes.length) return;
    propsBusy = true;
    changes.reduce((p, c) => p.then(() => fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(c)
    }).then((r) => r.json()).then((res) => { if (res && res.items) cartCache = res; })), Promise.resolve())
      .catch(() => {})
      .then(() => { propsBusy = false; });
  }

  class F100Ladder extends HTMLElement {
    connectedCallback() {
      try { this.tiers = JSON.parse(this.querySelector('[data-f100-tiers]').textContent); }
      catch (e) { this.tiers = []; }
      this.rows = Array.from(this.querySelectorAll('[data-tier]'));
      this.next = this.querySelector('[data-next]');
      this.bar = this.querySelector('[data-bar]');
      this.gifts = this.querySelector('[data-gifts]');
      this.max = parseInt(this.getAttribute('data-max') || '10', 10);
      ladders.add(this);
      const initial = parseInt(this.getAttribute('data-count') || '0', 10);
      this.render({ item_count: initial, items: [] });
      if (cartCache) this.render(cartCache); else refreshAll();
    }
    disconnectedCallback() { ladders.delete(this); }
    render(cart) {
      const count = printCount(cart);
      const hasSet = hasSetItem(cart);
      let nextTier = null;
      const names = [];
      this.rows.forEach((row) => {
        const min = parseInt(row.getAttribute('data-tier'), 10);
        const isSets = row.hasAttribute('data-sets');
        const on = isSets ? hasSet : (hasSet || count >= min);
        row.classList.toggle('is-on', on);
        row.classList.remove('is-next');
        if (on && row.getAttribute('data-gift-name')) names.push(row.getAttribute('data-gift-name'));
        if (!isSets && !row.hasAttribute('data-base') && !on && nextTier === null) nextTier = { min, row };
      });
      this.classList.toggle('is-set', hasSet);
      if (this.bar) {
        /* The bar lines up with the tiles: it fills exactly to the right edge of the last unlocked tile
           (tiles are equal width with a gap between them, so the maths accounts for the gaps) */
        const tiles = this.rows.filter((r) => !r.hasAttribute('data-sets'));
        const n = tiles.length;
        const k = tiles.filter((r) => r.classList.contains('is-on')).length;
        let w = '0%';
        if (hasSet || (n > 0 && k >= n)) w = '100%';
        else if (n > 0 && k > 0) {
          const grid = tiles[0].parentElement;
          const gap = grid ? parseFloat(getComputedStyle(grid).columnGap) || 0 : 0;
          w = 'calc(' + k + ' * (100% + ' + gap + 'px) / ' + n + ' - ' + gap + 'px)';
        }
        this.bar.style.width = w;
      }
      if (this.gifts) this.gifts.textContent = names.length ? names.join(', ') : 'None yet';
      if (this.next) {
        if (hasSet) {
          this.next.textContent = 'Complete Set in cart: 25% off, every gift and the special extras are yours.';
          this.next.classList.add('is-max');
        } else if (count === 0) {
          this.next.textContent = this.getAttribute('data-empty-text') || 'Add prints to unlock discounts and gifts.';
          this.next.classList.remove('is-max');
        } else if (nextTier) {
          const need = nextTier.min - count;
          const d = nextTier.row.getAttribute('data-discount') || '';
          const g = nextTier.row.getAttribute('data-gift') || '';
          this.next.textContent = count + (count === 1 ? ' print' : ' prints') + ' in cart. Add ' + need + ' more to unlock ' + d + (g ? ' + ' + g : '') + '.';
          this.next.classList.remove('is-max');
          nextTier.row.classList.add('is-next');
        } else {
          this.next.textContent = count + ' prints in cart. Top tier unlocked: 20% off + every gift.';
          this.next.classList.add('is-max');
        }
      }
    }
  }
  if (!customElements.get('f100-ladder')) customElements.define('f100-ladder', F100Ladder);

  /* ---------- in / cm unit toggle (shared by every card) ---------- */
  function toCm(dims) {
    // "8.5x11" -> "21.6x27.9 cm"
    const parts = String(dims).split('x').map((n) => parseFloat(n));
    if (parts.length !== 2 || parts.some(isNaN)) return '';
    const f = (n) => (Math.round(n * 2.54 * 10) / 10).toString().replace(/\.0$/, '');
    return f(parts[0]) + 'x' + f(parts[1]) + ' cm';
  }
  function fillCm(root) {
    (root || document).querySelectorAll('[data-dims]').forEach((el) => {
      const cm = el.querySelector('[data-cm]');
      if (cm && !cm.textContent) cm.textContent = toCm(el.getAttribute('data-dims'));
    });
  }
  function setUnit(unit) {
    document.documentElement.classList.toggle('f100-cm', unit === 'cm');
    document.querySelectorAll('[data-unit]').forEach((b) => b.classList.toggle('is-on', b.getAttribute('data-unit') === unit));
    try { localStorage.setItem('f100_unit', unit); } catch (e) {}
  }
  function initUnit() {
    let unit = 'in';
    try { unit = localStorage.getItem('f100_unit') || 'in'; } catch (e) {}
    setUnit(unit);
    document.querySelectorAll('[data-unit]').forEach((b) => {
      if (b.__f100) return; b.__f100 = true;
      b.addEventListener('click', () => setUnit(b.getAttribute('data-unit')));
    });
  }
  document.addEventListener('DOMContentLoaded', () => { fillCm(); initUnit(); });
  fillCm(); initUnit();

  /* ---------- Product card: size pills + add to cart ---------- */
  class F100Card extends HTMLElement {
    connectedCallback() {
      this.sizes = Array.from(this.querySelectorAll('[data-size]'));
      this.priceOut = this.querySelector('[data-price-out]');
      this.add = this.querySelector('[data-add]');
      this.label = this.querySelector('[data-add-label]');
      this.sizes.forEach((b) => b.addEventListener('click', () => this.pick(b)));
      if (this.add) this.add.addEventListener('click', () => this.addToCart());
      fillCm(this);
      this.renderPrice();
    }
    pick(btn) {
      if (btn.disabled) return;
      this.sizes.forEach((b) => b.classList.toggle('is-on', b === btn));
      if (this.add) this.add.setAttribute('data-id', btn.getAttribute('data-id'));
      this.renderPrice();
    }
    eligible() {
      const type = (this.getAttribute('data-type') || '').trim().toLowerCase();
      if (type === 'fine art print') return true;
      return (' ' + (this.getAttribute('data-colls') || '') + ' ').indexOf(' ' + ELIGIBLE + ' ') > -1;
    }
    renderPrice() {
      if (!this.priceOut) return;
      /* price source: the selected size pill, or the card itself for single-variant products */
      const on = this.sizes.find((b) => b.classList.contains('is-on')) || this.sizes[0] || this;
      const retail = on.getAttribute('data-vprice') || '';
      const cents = parseInt(on.getAttribute('data-vcents') || '0', 10);
      const compare = on.getAttribute('data-vcompare') || '';
      const was = this.querySelector('[data-price-was]');
      let wasText = '';
      if (currentPct > 0 && cents > 0 && this.eligible()) {
        this.priceOut.textContent = fmtLike(retail, cents * (1 - currentPct / 100));
        wasText = compare || retail;
      } else {
        this.priceOut.textContent = retail;
        wasText = compare; /* "compare at" price set on the product (e.g. the Mystery packs) */
      }
      if (was) was.textContent = wasText;
      if (this.add) this.add.classList.toggle('has-was', !!wasText);
    }
    addToCart() {
      const id = this.add.getAttribute('data-id');
      if (!id || this.add.disabled) return;
      this.add.classList.add('is-loading');
      this.add.disabled = true;
      const qty = this.qty ? Math.max(1, parseInt(this.qty.value, 10) || 1) : 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
      })
        .then((r) => r.json())
        .then((res) => {
          this.add.classList.remove('is-loading');
          this.add.disabled = false;
          if (res.status) { alert(res.description || 'Could not add to cart'); return; }
          const old = this.label ? this.label.textContent : '';
          if (this.label) this.label.textContent = 'Added';
          this.add.classList.add('is-added');
          setTimeout(() => { if (this.label) this.label.textContent = old; this.add.classList.remove('is-added'); }, 1600);
          cartCache = null;
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
          const drawer = document.querySelector('cart-items');
          setTimeout(() => {
            if (drawer && typeof drawer.openCartDrawer === 'function') drawer.openCartDrawer();
            refreshAll();
          }, 350);
        })
        .catch(() => { this.add.classList.remove('is-loading'); this.add.disabled = false; });
    }
  }
  if (!customElements.get('f100-card')) customElements.define('f100-card', F100Card);

  /* ---------- Product page (sections/f100-product.liquid) ----------
     Same pills / price / add-to-cart as a card, plus the gallery, quantity and the
     "x% off with N prints in your cart" note under the price. */
  class F100Product extends F100Card {
    connectedCallback() {
      this.sizes = Array.from(this.querySelectorAll('[data-size]'));
      this.priceWrap = this.querySelector('.f100-pd__price');
      this.priceOut = this.querySelector('[data-price-out]');
      this.wasOut = this.querySelector('[data-price-was]');
      this.saveOut = this.querySelector('[data-price-save]');
      this.noteOut = this.querySelector('[data-price-note]');
      this.add = this.querySelector('[data-add]');
      this.label = this.querySelector('[data-add-label]');
      this.idInput = this.querySelector('[data-pd-id]');
      this.qty = this.querySelector('[data-pd-qty]');
      this.form = this.querySelector('[data-pd-form]');
      this.main = this.querySelector('[data-pd-main]');
      this.tag = this.querySelector('[data-pd-tag]');
      this.thumbs = Array.from(this.querySelectorAll('[data-pd-thumb]'));
      this.sizes.forEach((b) => b.addEventListener('click', () => this.pick(b)));
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.addToCart(); });
      else if (this.add) this.add.addEventListener('click', () => this.addToCart());
      const dec = this.querySelector('[data-qty-dec]');
      const inc = this.querySelector('[data-qty-inc]');
      if (dec && this.qty) dec.addEventListener('click', () => { this.qty.value = Math.max(1, (parseInt(this.qty.value, 10) || 1) - 1); });
      if (inc && this.qty) inc.addEventListener('click', () => { this.qty.value = (parseInt(this.qty.value, 10) || 1) + 1; });
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(t)));
      fillCm(this);
      this.renderPrice();
    }
    pick(btn) {
      if (btn.disabled) return;
      this.sizes.forEach((b) => b.classList.toggle('is-on', b === btn));
      const id = btn.getAttribute('data-id');
      if (this.add) this.add.setAttribute('data-id', id);
      if (this.idInput) this.idInput.value = id;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        history.replaceState(null, '', url.toString());
      } catch (e) {}
      this.renderPrice();
    }
    show(t) {
      this.thumbs.forEach((x) => x.classList.toggle('is-on', x === t));
      if (this.main) {
        const srcset = t.getAttribute('data-srcset');
        this.main.src = t.getAttribute('data-src') || this.main.src;
        if (srcset) this.main.srcset = srcset;
        this.main.alt = t.getAttribute('data-alt') || '';
      }
      if (this.tag) {
        const l = t.getAttribute('data-label') || '';
        this.tag.textContent = l;
        this.tag.style.display = l ? '' : 'none';
      }
    }
    renderPrice() {
      if (!this.priceOut) return;
      const on = this.sizes.find((b) => b.classList.contains('is-on')) || this.sizes[0] || this;
      const retail = on.getAttribute('data-vprice') || '';
      const cents = parseInt(on.getAttribute('data-vcents') || '0', 10);
      const compare = on.getAttribute('data-vcompare') || '';
      const save = on.getAttribute('data-vsave') || '';
      let now = retail, was = compare, note = '', saveText = save ? 'Save ' + save : '';
      const next = nextTierInfo(currentCount);
      const plural = (n) => n + (n === 1 ? ' print' : ' prints');
      if (currentPct > 0 && cents > 0 && this.eligible()) {
        now = fmtLike(retail, cents * (1 - currentPct / 100));
        was = compare || retail;
        note = 'You are saving ' + currentPct + '% on your order with ' + plural(currentCount) + ' in your cart' +
          (next ? ', add ' + (next.min - currentCount) + ' more to save ' + next.pct + '%.' : '.');
        saveText = '';
      } else if (this.eligible() && currentCount > 0 && next) {
        /* one print in the cart: nudge toward the first discount */
        note = 'Add ' + (next.min - currentCount) + ' more ' + ((next.min - currentCount) === 1 ? 'print' : 'prints') + ' to your cart to save ' + next.pct + '% on your order.';
      }
      this.priceOut.textContent = now;
      if (this.wasOut) this.wasOut.textContent = was;
      if (this.saveOut) this.saveOut.textContent = saveText;
      if (this.noteOut) this.noteOut.textContent = note;
      if (this.priceWrap) this.priceWrap.classList.toggle('f100-pd--deal', !!was);
    }
  }
  if (!customElements.get('f100-product')) customElements.define('f100-product', F100Product);

  /* ---------- Product grid: in-page collection filter + Load more ---------- */
  class F100Grid extends HTMLElement {
    connectedCallback() {
      this.page = parseInt(this.getAttribute('data-page') || '20', 10) || 20;
      const grid = this.querySelector('[data-grid]');
      this.cards = grid ? Array.from(grid.querySelectorAll('[data-colls]')) : [];
      this.more = this.querySelector('[data-load-more]');
      this.countEl = this.querySelector('[data-grid-count]');
      this.empty = this.querySelector('[data-grid-empty]');
      this.chips = Array.from(this.querySelectorAll('[data-filter]'));
      this.classList.add('f100-ready');
      if (!this.cards.length || !this.more) return;
      this.filter = '';
      this.shown = this.page;
      this.chips.forEach((c) => c.addEventListener('click', () => {
        this.filter = c.getAttribute('data-filter') || '';
        this.shown = this.page;
        this.chips.forEach((x) => x.classList.toggle('is-on', x === c));
        this.querySelectorAll('a.f100__chip').forEach((x) => x.classList.remove('is-on'));
        this.render();
      }));
      this.more.addEventListener('click', () => { this.shown += this.page; this.render(); });
      this.render();
    }
    render() {
      const f = this.filter;
      let match = 0, visible = 0;
      this.cards.forEach((card) => {
        const ok = !f || (' ' + (card.getAttribute('data-colls') || '') + ' ').indexOf(' ' + f + ' ') > -1;
        if (ok) match++;
        const show = ok && match <= this.shown;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      this.more.style.display = visible < match ? '' : 'none';
      if (this.countEl) this.countEl.textContent = match ? 'Showing ' + visible + ' of ' + match : '';
      if (this.empty) this.empty.style.display = match ? 'none' : '';
    }
  }
  if (!customElements.get('f100-grid')) customElements.define('f100-grid', F100Grid);

  /* Tier preview images live in the cart-ladder template (Overlay group);
     copy them into any ladder on the page that has empty image slots (product page). */
  function syncTierImages() {
    const tpl = document.querySelector('[data-f100-cart-ladder]');
    if (!tpl) return;
    const src = {};
    tpl.content.querySelectorAll('[data-tier-img]').forEach((el) => { const img = el.querySelector('img'); if (img) src[el.getAttribute('data-tier-img')] = img.outerHTML; });
    document.querySelectorAll('f100-ladder [data-tier-img]').forEach((el) => {
      if (!el.querySelector('img') && src[el.getAttribute('data-tier-img')]) el.innerHTML = src[el.getAttribute('data-tier-img')];
    });
  }
  document.addEventListener('DOMContentLoaded', syncTierImages);
  syncTierImages();

  /* Drop the ladder into the cart drawer (above the line items) once it renders */
  function injectDrawerLadder() {
    const tpl = document.querySelector('[data-f100-cart-ladder]');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!tpl || !drawer) return;
    if (drawer.querySelector('f100-ladder')) return;
    const holder = drawer.querySelector('[data-items-holder]') || drawer.querySelector('[data-cart-drawer-body]');
    if (!holder) return;
    const frag = document.importNode(tpl.content, true);
    const el = frag.querySelector('f100-ladder');
    if (!el) return;
    el.setAttribute('data-in-drawer', '');
    const wrap = document.createElement('div');
    wrap.className = 'cart-drawer__block f100-drawer-block';
    const ref = drawer.querySelector('.cart-drawer__block--title') || drawer.querySelector('.cart-drawer__block');
    if (ref) {
      const cs = getComputedStyle(ref);
      /* same gap both sides (the title block has extra right padding for its close button) */
      if (parseFloat(cs.paddingLeft) > 0) { wrap.style.paddingLeft = cs.paddingLeft; wrap.style.paddingRight = cs.paddingLeft; }
      else { wrap.style.paddingLeft = '20px'; wrap.style.paddingRight = '20px'; }
    } else { wrap.style.paddingLeft = '20px'; wrap.style.paddingRight = '20px'; }
    wrap.appendChild(el);
    if (holder.hasAttribute('data-items-holder')) holder.parentNode.insertBefore(wrap, holder);
    else holder.appendChild(wrap);
    syncTierImages();
  }

  /* Re-count whenever the theme touches the cart */
  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:refresh', 'theme:cart:open'].forEach((ev) => {
    document.addEventListener(ev, () => { injectDrawerLadder(); setTimeout(refreshAll, 250); });
  });
  document.addEventListener('DOMContentLoaded', () => { injectDrawerLadder(); refreshAll(); });
  injectDrawerLadder();
  refreshAll();
  /* The drawer swaps its line items via fetch; watch for that too */
  const mo = new MutationObserver(() => {
    clearTimeout(mo.t);
    mo.t = setTimeout(refreshAll, 300);
  });
  function watchDrawer() {
    document.querySelectorAll('[data-items-holder], [data-cart-price-holder]').forEach((holder) => {
      if (!holder.__f100watched) { holder.__f100watched = true; mo.observe(holder, { childList: true, subtree: true }); }
    });
  }
  document.addEventListener('theme:cart:loaded', watchDrawer);
  document.addEventListener('DOMContentLoaded', watchDrawer);
  watchDrawer();
})();
